export default __webpack_public_path__ + "static/media/Bracers of the Furious Swipe.754fa571.jpg";